import type { NavigationBehaviorOptions, Router } from '@angular/router';
import type { OnyxOptional } from '@onyx/angular';
import { OnyxFormMode } from '@onyx/angular';
import { isString } from 'lodash';
import { RouterStateKey } from '../enums/router-state-key';

export class NavigationHelper {
  public static withOrigin(
    router: Router,
    extras?: NavigationBehaviorOptions,
  ): NavigationBehaviorOptions {
    return {
      ...extras,
      state: { ...extras?.state, [RouterStateKey.ORIGIN]: router.url },
    };
  }

  public static getReturnToOrigin(
    router: Router,
    options: {
      mode: () => OnyxFormMode;
      uuid: () => OnyxOptional<string>;
      listUrl: string;
      cardUrl: string;
      openModal: (uuid: string) => void;
    },
  ): (force: boolean) => void {
    const { listUrl, cardUrl, openModal } = options;

    const navigation = router.currentNavigation();
    const origin = navigation?.extras.state?.[RouterStateKey.ORIGIN];
    const previousUrl = navigation?.previousNavigation?.finalUrl;

    const originUrl = isString(origin)
      ? origin
      : previousUrl
        ? router.serializeUrl(previousUrl)
        : null;

    return (force) => {
      const mode = options.mode();
      const uuid = options.uuid();

      if (
        originUrl &&
        (mode === OnyxFormMode.EDIT || !originUrl.startsWith(listUrl))
      ) {
        router.navigateByUrl(originUrl).then((navigated) => {
          if (navigated && mode === OnyxFormMode.ADD && uuid && !force) {
            openModal(uuid);
          }
        });
        return;
      }

      router.navigateByUrl(
        force || !uuid ? listUrl : cardUrl.replace(':uuid', uuid),
      );
    };
  }
}
